import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'

import { Link } from 'react-router-dom'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'


const Processo = (props) => {


    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id




    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    const [questao20, setQuestao20] = useState()
    const [questao21, setQuestao21] = useState()
    const [questao22, setQuestao22] = useState()
    const [questao23, setQuestao23] = useState()
    const [questao24, setQuestao24] = useState()
    const [questao25, setQuestao25] = useState()
    const [questao26, setQuestao26] = useState()
    const [questao27, setQuestao27] = useState()
    
    const [totalPendencias, setTotalPendencias] = useState(0)


    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))
    var [compras_id, setCompras_id] = useState()

    var [subLegislacao, setSubLegislacao] = useState()
    var [pcVerRealNec, setPcVerRealNec] = useState('')
    var [pcPref, setPcPref] = useState('')
    var [pcEspec, setPcEspec] = useState('')
    var [pcVerAtend, setPcVerAtend] = useState('')
    var [pcTestaProd, setPcTestaProd] = useState('')
    var [pcInclEspec, setPcIncEspec] = useState('')
    var [pcVerConf, setPcVerConf] = useState('')
    var [analiseCusto, setAnaliseCusto] = useState('')
    var [custosExt, setCustosExt] = useState('')
    var [grauTox, setGrauTox] = useState('')
    var [potDanos, setPotDanos] = useState('')
    var [potImpacto, setPotImpacto] = useState('')
    
    //var [usoRecBio, setUsoRecBio] = useState()
    
    var [forContr, setForContr] = useState('')
    var [possibCompRes, setPossibCompRes] = useState('')
    var [nivelDesenv, setNivelDesenv] = useState('')
    var [abordCiclo, setAbordCiclo] = useState('')
    var [coletaInform, setColetaInform] = useState()
    var [crCondTrab, setCrCondTrab] = useState()
    var [crAuditTerc, setCrAuditTerc] = useState()
    var [crDispSist, setCrDispSist] = useState()
    var [crRotul, setCrRotul] = useState()
    var [crCompOrigem, setCrCompOrigem] = useState()
    var [crPlanoGerenc, setCrPlanoGerenc] = useState()
    var [crGestaoRec, setCrGestaoRec] = useState()
    var [crInventGEE, setCrInventGEE] = useState()
    var [crProgIntegr, setCrProgIntegr] = useState()
    var [crLocaliza, setCrLocaliza] = useState()
    var [crPartGrupos, setCrPartGrupos] = useState()
    
    var [praticaVeracidSolComp, setPraticaVeracidSolComp] = useState()
    
    var [praticaVeracidOutra, setPraticaVeracidOutra] = useState()
    var [paOfereceApoio, setPaOfereceApoio] = useState()
    var [paDesenvProj, setPaDesenvProj] = useState()
    var [paComPubl, setPaComPubl] = useState()
    var [paComPrat, setPaComPrat] = useState()
    var [paOutra, setPaOutra] = useState()
    var [paOutraDescri, setPaOutraDescri] = useState('')
    var [oportunidadeMelhorias, setOportunidadeMelhorias] = useState()


    var [pcInclEspec, setPcInclEspec] = useState('')
    var [initComb, setInitComb] = useState()
    var [praticaVeracidSolAuto, setPraticaVeracidSolAuto] = useState()
    var [praticaVeracidRealAud, setPraticaVeracidRealAud] = useState()
    var [praticaVeracidOut, setPraticaVeracidOut] = useState()

    var [praticaVeracidNaoAdotada, setPraticaVeracidNaoAdotada] = useState()
    var [paNaoTem, setPaNaoTem] = useState()
    

    function salvaProcesso() {

        var dataPost = {

            subLegislacao: subLegislacao,
            pcVerRealNec: pcVerRealNec,
            pcPref: pcPref,
            pcEspec: pcEspec,
            pcVerAtend: pcVerAtend,
            pcTestaProd: pcTestaProd,
            pcInclEspec: pcInclEspec,
            pcVerConf: pcVerConf,
            analiseCusto: analiseCusto,
            custosExt: custosExt,
            grauTox: grauTox,
            potDanos: potDanos,
            potImpacto: potImpacto,
            
            forContr: forContr,
            possibCompRes: possibCompRes,
            nivelDesenv: nivelDesenv,
            abordCiclo: abordCiclo,
            coletaInform: coletaInform,
            crCondTrab: crCondTrab,
            crAuditTerc: crAuditTerc,
            crDispSist: crDispSist,
            crRotul: crRotul,
            crCompOrigem: crCompOrigem,
            crPlanoGerenc: crPlanoGerenc,
            crGestaoRec: crGestaoRec,
            crInventGEE: crInventGEE,
            crProgIntegr: crProgIntegr,
            crLocaliza: crLocaliza,
            crPartGrupos: crPartGrupos,
            
            praticaVeracidSolComp: praticaVeracidSolComp,
            
            praticaVeracidOutra: praticaVeracidOutra,
            paOfereceApoio: paOfereceApoio,
            paDesenvProj: paDesenvProj,
            paComPubl: paComPubl,
            paComPrat: paComPrat,
            paOutra: paOutra,
            paOutraDescri: paOutraDescri,
            oportunidadeMelhorias: oportunidadeMelhorias,


            pcInclEspec: pcInclEspec,
            intComb: initComb,
            praticaVeracidSolAuto: praticaVeracidSolAuto,
            
            praticaVeracidRealAud: praticaVeracidRealAud,
            
            praticaVeracidOut: praticaVeracidOut,

        }


        //console.log(dataPost)


        if (praticaVeracidOut && (praticaVeracidOutra == null || praticaVeracidOutra == '')) {

            window.toastr.error('Por favor, informe a(s) outra(s) pratica(s) adotada(s) na questão 25!')
            return false

        }



        if (paOutra && (paOutraDescri == '' || paOutraDescri == null)) {

            window.toastr.error('Por favor, informe a(s) outra(s) pratica(s) adotada(s) na questão 26!')
            return false

        }


         window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (compras_id) {


                        
                        api.put(`comprasProcesso/${compras_id}`, dataPost).then((result) => {

                            //console.log(result.data, '!!')
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {


                        api.post(`comprasProcesso/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                            //console.log(result.data)

                            setCompras_id(result.data[0].compras_id)
                            window.toastr.success('Registro salvo com sucesso!')
                            //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })



                    }



                },

		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });
        



        

    }


    async function carregaComprasProcesso() {

        setCompras_id()
        setSubLegislacao()
        setPcVerRealNec('')
        setPcPref('')
        setPcEspec('')
        setPcVerAtend('')
        setPcTestaProd('')
        setPcInclEspec('')
        setPcVerConf('')
        setAnaliseCusto('')
        setCustosExt('')
        setGrauTox('')
        setPotDanos('')
        setPotImpacto('')
        setForContr('')
        setPossibCompRes('')
        setNivelDesenv('')
        setAbordCiclo('')
        setColetaInform()
        setCrCondTrab()
        setCrAuditTerc()
        setCrDispSist()
        setCrRotul()
        setCrCompOrigem()
        setCrPlanoGerenc()
        setCrGestaoRec()
        setCrInventGEE()
        setCrProgIntegr()
        setCrLocaliza()
        setCrPartGrupos()
        setPraticaVeracidSolComp()
        setPraticaVeracidOutra()
        setPaOfereceApoio()
        setPaDesenvProj()
        setPaComPubl()
        setPaComPrat()
        setPaOutra()
        setPaNaoTem()
        
        setOportunidadeMelhorias()
        
        setInitComb()
        setPraticaVeracidSolAuto()
        setPraticaVeracidRealAud()
        setPraticaVeracidOut()
        setPaOutraDescri()
        setPraticaVeracidNaoAdotada()
        

        if (ano && adesao_institucional_id) {


            await api.get(`comprasProcesso/${adesao_institucional_id}/${ano}`).then((result) => {


                console.log(result.data)

                if (result.data[0]) {

                    var data = result.data[0]

                    setCompras_id(data.compras_id)

                    setSubLegislacao(data.subLegislacao)
                    setPcVerRealNec(data.pcVerRealNec)
                    setPcPref(data.pcPref)
                    setPcEspec(data.pcEspec)
                    setPcVerAtend(data.pcVerAtend)
                    setPcTestaProd(data.pcTestaProd)
                    setPcInclEspec(data.pcInclEspec)
                    setPcVerConf(data.pcVerConf)
                    setAnaliseCusto(data.analiseCusto)
                    setCustosExt(data.custosExt)
                    setGrauTox(data.grauTox)
                    setPotDanos(data.potDanos)
                    setPotImpacto(data.potImpacto)
                    setForContr(data.forContr)
                    setPossibCompRes(data.possibCompRes)
                    setNivelDesenv(data.nivelDesenv)
                    setAbordCiclo(data.abordCiclo)
                    setColetaInform(data.coletaInform)
                    setCrCondTrab(data.crCondTrab)
                    setCrAuditTerc(data.crAuditTerc)
                    setCrDispSist(data.crDispSist)
                    setCrRotul(data.crRotul)
                    setCrCompOrigem(data.crCompOrigem)
                    setCrPlanoGerenc(data.crPlanoGerenc)
                    setCrGestaoRec(data.crGestaoRec)
                    setCrInventGEE(data.crInventGEE)
                    setCrProgIntegr(data.crProgIntegr)
                    setCrLocaliza(data.crLocaliza)
                    setCrPartGrupos(data.crPartGrupos)
                    setPraticaVeracidSolComp(data.praticaVeracidSolComp)
                    setPraticaVeracidOutra(data.praticaVeracidOutra)
                    setPaOfereceApoio(data.paOfereceApoio)
                    setPaDesenvProj(data.paDesenvProj)
                    setPaComPubl(data.paComPubl)
                    setPaComPrat(data.paComPrat)
                    setPaOutra(data.paOutra)
                    setPaOutraDescri(data.paOutraDescri)
                    setOportunidadeMelhorias(data.oportunidadeMelhorias)
                    setPcInclEspec(data.pcInclEspec)
                    setInitComb(data.intComb)
                    setPraticaVeracidSolAuto(data.praticaVeracidSolComp)
                    setPraticaVeracidRealAud(data.praticaVeracidRealAud)
                    setPraticaVeracidOut(data.praticaVeracidOut)
                    setPraticaVeracidNaoAdotada(data.praticaVeracidNaoAdotada)
                    setPaNaoTem(data.paNaoTem)

                    
                }


            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    useEffect(() => {
        

        carregaComprasProcesso()


        setQuestao20()
        setQuestao21()
        setQuestao22()
        setQuestao23()
        setQuestao24()
        setQuestao25()
        setQuestao26()
        setQuestao27()
        
        
        


    }, [ano, adesao_institucional_id])





    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao20()
        setQuestao21()
        setQuestao22()
        setQuestao23()
        setQuestao24()
        setQuestao25()
        setQuestao26()
        setQuestao27()
        
        
        

        if (compras_id) {

            var dataPost = {

                formulario_id: compras_id,
                desafio: 'Compras',

            }
            console.log('aqui')

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '20. As compras e contratações em sua organização estão submetidas à legislação nacional de licitações e contratos públicos?':

                                totalErros = totalErros + 1
                                setQuestao20('red')
    
                            break

                            case '21. Como é a aplicação de critérios de sustentabilidade em cada uma das etapas do processo de compras e contratações em sua organização?':

                                totalErros = totalErros + 1
                                setQuestao21('red')

                            break

                            case '22. Com que abrangência os fatores a seguir são considerados nas decisões sobre compras em sua organização?':

                                totalErros = totalErros + 1
                                setQuestao22('red')

                            break

                            case '23. Como são coletadas as informações para qualificação / avaliação dos fornecedores considerando critérios de sustentabilidade em sua organização?':

                                totalErros = totalErros + 1
                                setQuestao23('red')

                            break

                            case '24. Quais dos critérios relacionados a seguir são utilizados por sua organização durante o processo de qualificação / avaliação de fornecedores?':

                                totalErros = totalErros + 1
                                setQuestao24('red')

                            break


                            case '25. Quais práticas são adotadas por sua organização para confirmar a veracidade das práticas em sustentabilidade informadas pelo fornecedor?':

                                totalErros = totalErros + 1
                                setQuestao25('red')

                            break

                            case '26. Quais práticas são adotadas por sua organização para orientar fornecedores com relação à adoção de critérios de sustentabilidade? (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao26('red')

                            break

                            case '27. Quanto ao monitoramento dos resultados e oportunidades de melhorias no processo de compras e contratações incluindo critérios de sustentabilidade, a sua organização:':

                                totalErros = totalErros + 1
                                setQuestao27('red')

                            break



                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {

        verificaValidacoes()

    }, [compras_id, verificaDesafio])





    return (

        <div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao20 }} onClick={() => {setEnunciado('20. As compras e contratações em sua organização estão submetidas à legislação nacional de licitações e contratos públicos?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            20. As compras e contratações em sua organização estão submetidas à legislação nacional de licitações e contratos públicos?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="subLegislacao" onClick={() => setSubLegislacao('S')} checked={ subLegislacao == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim
                            </td>
                            
                        </tr>       
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="subLegislacao" onClick={() => setSubLegislacao('N')} checked={ subLegislacao == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="subLegislacao" onClick={() => setSubLegislacao('A')} checked={ subLegislacao == 'A' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            A instituição atua em regime híbrido (público e privado)
                            </td>
                            
                        </tr>     
                            
                    

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao21 }} onClick={() => {setEnunciado('21. Como é a aplicação de critérios de sustentabilidade em cada uma das etapas do processo de compras e contratações em sua organização?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            21. Como é a aplicação de critérios de sustentabilidade em cada uma das etapas do processo de compras e contratações em sua organização?
                            </Link>                           

                            </td>
                        </tr>

                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <br/><br/>
                            <b>PRÉ-COMPRA</b>
                            </td>
                        </tr>

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Verifica a&nbsp;
                                
                                <span class="wrapper2"> real necessidade 
                                    <div class="tooltip">
                                        É comum indivíduos e organizações reabastecerem itens habituais ou renovarem acordos de serviços existentes sem considerar ou reavaliar a real necessidade desses produtos e serviços. A compra mais sustentável pode ser aquela que não é feita. É possível, por exemplo, estender a vida útil de ativos atuais ou repará-los, recondicioná-los ou reprocessá-los em vez de substituí-los.
                                    </div>
                                </span>&nbsp;
                                
                                do produto / serviço?
                                </div>
                            </td>
                            <td>
                                <select id="pcVerRealNec" class="form-control" value={pcVerRealNec} onChange={event => setPcVerRealNec(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>       

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Aplica critérios de sustentabilidade para <b>dar preferência</b> a produtos / serviços / fornecedores?
                                </div>
                            </td>
                            <td>
                                <select id="pcPref" class="form-control"  value={pcPref} onChange={event => setPcPref(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Aplica critérios de sustentabilidade para <b>especificar</b> produtos / serviços / fornecedores?
                                </div>
                            </td>
                            <td>
                                <select id="pcEspec" class="form-control" value={pcEspec} onChange={event => setPcEspec(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                         <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <br/><br/>
                            <b>COMPRA</b>
                            </td>
                        </tr>

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Verifica o atendimento dos critérios de sustentabilidade na seleção das propostas?
                                </div>
                            </td>
                            <td>
                                <select id="pcVerAtend" class="form-control" value={pcVerAtend} onChange={event => setPcVerAtend(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Testa produtos / serviços ou solicita amostras / laudos?
                                </div>
                            </td>
                            <td>
                                <select id="pcTestaProd" class="form-control" value={pcTestaProd} onChange={event => setPcTestaProd(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <br/><br/>
                            <b>PÓS-COMPRA</b>
                            </td>
                        </tr>

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Inclui especificações de sustentabilidade nos contratos?
                                </div>
                            </td>
                            <td>
                                <select id="pcInclEspec" class="form-control" value={pcInclEspec} onChange={event => setPcInclEspec(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Verifica a conformidade dos produtos recebidos / serviços prestados com relação aos critérios de sustentabilidade?
                                </div>
                            </td>
                            <td>
                                <select id="pcVerConf" class="form-control" value={pcVerConf} onChange={event => setPcVerConf(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim, para várias categorias</option>
                                    <option value="P"  >Sim, para categorias prioritárias</option>
                                    <option value="A"  >Apenas em casos pontuais</option>
                                    <option value="N"  >Não aplica</option>
                                </select>
                            </td>
                            
                            
                        </tr> 
                        
                    

                    </tbody>
                </Table>

            </div>




            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao22 }} onClick={() => {setEnunciado('22. Com que abrangência os fatores a seguir são considerados nas decisões sobre compras em sua organização?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            22. Com que abrangência os fatores a seguir são considerados nas decisões sobre compras em sua organização?
                            </Link>
                            
                            </td>
                        </tr>

                       
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Análise do&nbsp;
					

                                    <span class="wrapper2"> Custo Total de Propriedade
                                        <div class="tooltip">
                                            Custos associados aos bens e serviços que incluem não apenas o seu preço de aquisição, mas também todos os custos inerentes à sua manutenção, tais como: consumo de água, consumo de energia, custos de manutenção, custo relacionado a descarte, dentre outros).
                                        </div>
                                    </span>

						
                                </div>
                            </td>
                            <td>
                                <select id="analiseCusto" class="form-control" value={analiseCusto} onChange={event => setAnaliseCusto(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2"> Custos de Externalidades sociais, econômicas e ambientais
                                    <div class="tooltip">
                                        Custos associados aos impactos sociais, ambientais e econômicos decorrentes de atividades de produção e consumo de bens e serviços.
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="custosExt" class="form-control" value={custosExt} onChange={event => setCustosExt(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr>      


                       

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Grau de toxicidade do produto, seus componentes ou dos insumos nele utilizados
						
                                </div>
                            </td>
                            <td>
                                <select id="grauTox" class="form-control" value={grauTox} onChange={event => setGrauTox(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Potencial de danos à saúde humana
						
                                </div>
                            </td>
                            <td>
                                <select id="potDanos" class="form-control" value={potDanos} onChange={event => setPotDanos(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Potencial dano ao meio ambiente
						
                                </div>
                            </td>
                            <td>
                                <select id="potImpacto" class="form-control" value={potImpacto} onChange={event => setPotImpacto(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Intensividade de combustíveis fósseis e emissões de GEE
						
                                </div>
                            </td>
                            <td>
                                <select id="initComb" class="form-control" value={initComb} onChange={event => setInitComb(event.target.value)} disabled> 
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Fornecimento por <span class="wrapper2">micro e pequenas empresas
                                <div class="tooltip">
                                    Grupo de empresas abrangidas pelo disposto na Lei Complementar nº 123/2006 (Estatuto Nacional da Microempresa e Empresa de Pequeno Porte) e suas alterações posteriores.
                                </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="forContr" class="form-control" value={forContr} onChange={event => setForContr(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Possibilidade de comprar um resultado desejado, em vez do equipamento que produz esse resultado 
                                <span class="wrapper2"> (produto como serviço - PaaS) 
                                    <div class="tooltip">
                                        Produto como serviço é o conceito de venda de serviços e resultados que um produto pode oferecer, e não o produto em si. 
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="possibCompRes" class="form-control" value={possibCompRes} onChange={event => setPossibCompRes(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 


                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Nível de desenvolvimento do fornecedor para sustentabilidade
						
                                </div>
                            </td>
                            <td>
                                <select id="nivelDesenv" class="form-control" value={nivelDesenv} onChange={event => setNivelDesenv(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2"> Abordagem do Ciclo de Vida 
                                    <div class="tooltip">
                                        Abordagem ou pensamento no ciclo de vida é um conceito que integra estratégias de produção e consumo sustentáveis, implicando que todos da cadeia de valor de um produto, do berço ao tumulo, tem uma responsabilidade e um papel a desempenhar, levando em consideração todos os efeitos externos relevantes.
                                    </div>
                                </span>
                                
                                (matérias primas, produção, distribuição, consumo, pós-consumo)
						
                                </div>
                            </td>
                            <td>
                                <select id="abordCiclo" class="form-control" value={abordCiclo} onChange={event => setAbordCiclo(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="T"  >Todas as categorias de produtos</option>
                                    <option value="P"  >Produtos selecionados por análise preliminar</option>
                                    <option value="A"  >Produtos cujo risco é amplamente conhecido</option>
                                    <option value="N"  >Não consideramos este fator</option>
                                </select>
                            </td>
                            
                            
                        </tr> 

                        

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao23 }} onClick={() => {setEnunciado('23. Como são coletadas as informações para qualificação / avaliação dos fornecedores considerando critérios de sustentabilidade em sua organização?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            23. Como são coletadas as informações para qualificação / avaliação dos fornecedores considerando critérios de sustentabilidade em sua organização?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="coletaInform" onClick={() => setColetaInform('C')} checked={ coletaInform == 'C' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Nosso sistema de cadastro de fornecedores contém perguntas gerais sobre sustentabilidade e informações adicionais para fornecedores de categorias específicas de produtos ou serviços
                            </td>
                            
                        </tr>    

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="coletaInform" onClick={() => setColetaInform('A')} checked={ coletaInform == 'A' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Nosso sistema de cadastro de fornecedores contém apenas perguntas gerais sobre sustentabilidade, mas informações adicionais são requisitadas durante os processos de compras para fornecedores de categorias específicas de produtos ou serviços 
                            </td>
                            
                        </tr>   


                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="coletaInform" onClick={() => setColetaInform('I')} checked={ coletaInform == 'I' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Nosso sistema de cadastro de fornecedores não contém perguntas sobre sustentabilidade, mas informações são requisitadas para fornecedores de categorias específicas de produtos ou serviços durante os processos de compras
				
                            </td>
                            
                        </tr>   

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="coletaInform" onClick={() => setColetaInform('N')} checked={ coletaInform == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                                Não coletamos informações sobre sustentabilidade dos nossos fornecedores
				
                            </td>
                            
                        </tr>   

                        
                        

                    </tbody>
                </Table>

            </div>




            <div className="col-md-12">


                <Table striped bordered hover>

                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao24 }} onClick={() => {setEnunciado('24. Quais dos critérios relacionados a seguir são utilizados por sua organização durante o processo de qualificação / avaliação de fornecedores?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            24. Quais dos critérios relacionados a seguir são utilizados por sua organização durante o processo de qualificação / avaliação de fornecedores?
                            </Link>
                            </td>
                        </tr>

                       
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Condições de trabalho ao longo da&nbsp;<span class="wrapper2">cadeia produtiva
                                    <div class="tooltip">
                                        Conjunto de etapas consecutivas, ao longo das quais os diversos insumos sofrem algum tipo de transformação, até a constituição de um produto final (bem ou serviço) e sua colocação no mercado.
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="crCondTrab" class="form-control" value={crCondTrab} onChange={event => setCrCondTrab(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2"> Auditoria de terceira parte&nbsp;
                                    <div class="tooltip">
                                        Uma auditoria de terceira parte corresponde a auditoria realizada por organizações externas independentes. Exemplo, auditoria externa realizada por órgão de acreditação para determinar cumprimento de orientações de determinada norma ISO.
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="crAuditTerc" class="form-control" value={crAuditTerc} onChange={event => setCrAuditTerc(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Certificação de Sistemas de Gestão (ex.: ISO 9000, ISO 14000, ISO 50001, ISO 31000)
						
                                </div>
                            </td>
                            <td>
                                <select id="crDispSist" class="form-control" value={crDispSist} onChange={event => setCrDispSist(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                <span class="wrapper2"> Rotulagem ou certificação socioambiental
                                    <div class="tooltip">
                                        Sistemas voluntários ou compulsórios para avaliação da conformidade de produtos e serviços com relação a critérios de sustentabilidade previamente definidos. Exemplos: certificações compulsórias e voluntárias do INMETRO, selos baseados em avaliação de terceira parte (Rotulagem Tipo I - ISO 14024) ou em autodeclarações ambientais (Rotulagem Tipo II - ISO 14021).
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="crRotul" class="form-control" value={crRotul} onChange={event => setCrRotul(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Comprovação de origem da matéria prima utilizada para fabricação do produto/equipamento
						
                                </div>
                            </td>
                            <td>
                                <select id="crCompOrigem" class="form-control" value={crCompOrigem} onChange={event => setCrCompOrigem(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   
                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Plano de gerenciamento de resíduos e efluentes formalizado e instituído
						
                                </div>
                            </td>
                            <td>
                                <select id="crPlanoGerenc" class="form-control" value={crPlanoGerenc} onChange={event => setCrPlanoGerenc(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Gestão de recursos naturais (água e energia)
						
                                </div>
                            </td>
                            <td>
                                <select id="crGestaoRec" class="form-control" value={crGestaoRec} onChange={event => setCrGestaoRec(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Inventário de emissões de GEE
						
                                </div>
                            </td>
                            <td>
                                <select id="crInventGEE" class="form-control" value={crInventGEE} onChange={event => setCrInventGEE(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                    Programa de integridade e compliance
						
                                </div>
                            </td>
                            <td>
                                <select id="crProgIntegr" class="form-control" value={crProgIntegr} onChange={event => setCrProgIntegr(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Localização, privilegiando&nbsp;
                                
                                <span class="wrapper2"> fornecedores locais
                                    <div class="tooltip">
                                        Fornecedor local consiste na organização ou pessoa que fornece um produto ou serviço à organização e que se baseia no mesmo mercado geográfico que a organização. A definição geográfica de 'local' pode incluir a comunidade em torno das operações, uma região dentro de um país ou um país. (Fonte: GRI 204 - tradução livre).
                                    </div>
                                </span>
						
                                </div>
                            </td>
                            <td>
                                <select id="crLocaliza" class="form-control" value={crLocaliza} onChange={event => setCrLocaliza(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        <tr>
                            <td style={{width: '520px'}}>
                                <div align="right">
                                Participação de&nbsp;
                                    
                                    <span class="wrapper2"> grupos minorizados
                                        <div class="tooltip">
                                            Grupos minorizados se refere a um grupo de pessoas que, de algum modo e em algum setor das relações sociais, se encontram numa situação de dependência ou desvantagem em relação a um outro grupo, denominado majoritário; exemplos: negros, imigrantes, refugiados, mulheres, LGBTQIA+, idosos, portadores de deficiências, entre outros. 
                                        </div>
                                    </span>&nbsp;
                                    em cargos de  liderança
						
                                </div>
                            </td>
                            <td>
                                <select id="crPartGrupos" class="form-control" value={crPartGrupos} onChange={event => setCrPartGrupos(event.target.value)} disabled>
                                    <option value="">[Selecione]</option>
                                    <option value="S"  >Sim</option>
                                    <option value="N"  >Não</option>
                                    <option value="A"  >Apenas em situações específicas</option>
                                </select>
                            </td>
                            
                            
                        </tr>   

                        

                    </tbody>
                    
                    
                </Table>

            </div>



            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao25 }} onClick={() => {setEnunciado('25. Quais práticas são adotadas por sua organização para confirmar a veracidade das práticas em sustentabilidade informadas pelo fornecedor?');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            25. Quais práticas são adotadas por sua organização para confirmar a veracidade das práticas em sustentabilidade informadas pelo fornecedor?
                            </Link>
                                
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="praticaVeracidSolComp" value={praticaVeracidSolComp} onChange={event => setPraticaVeracidSolComp(event.target.checked)} checked={ praticaVeracidSolComp ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Solicita documentação comprobatória (evidências) das práticas em sustentabilidade informadas
                            </td>
                            
                        </tr>  

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="praticaVeracidSolAuto" value={praticaVeracidSolAuto} onChange={event => setPraticaVeracidSolAuto(event.target.checked)} checked={ praticaVeracidSolAuto ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Solicita documento de autodeclaração de cumprimento das práticas em sustentabilidade informadas

                            </td>
                            
                        </tr>    

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="praticaVeracidRealAud" value={praticaVeracidRealAud} onChange={event => setPraticaVeracidRealAud(event.target.checked)} checked={ praticaVeracidRealAud ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Realiza auditoria in loco para confirmar as práticas em sustentabilidade informadas

                            </td>
                            
                        </tr> 

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="praticaVeracidNaoAdotada" value={praticaVeracidNaoAdotada} onChange={event => setPraticaVeracidNaoAdotada(event.target.checked)} checked={ praticaVeracidNaoAdotada ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Prática não adotada pela organização 
                            </td>
                            
                        </tr>   
  

                        <tr style={{display: 'none'}}>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="praticaVeracidOut" value={praticaVeracidOut} onChange={event => setPraticaVeracidOut(event.target.checked)} checked={ praticaVeracidOut ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outra

                            </td>
                            
                        </tr>  
                        <tr style={{ display: praticaVeracidOut ? 'table-row' : 'none'}} >
                            <td colspan="2">
                                
                                <input type="text" id="praticaVeracidOutra" maxlength="255" value={praticaVeracidOutra} onChange={event => setPraticaVeracidOutra(event.target.value)} disabled />
                                
                            </td>
                           
                        </tr>  
                        
                    

                    </tbody>
                </Table>

            </div>



            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao26 }} onClick={() => {setEnunciado('26. Quais práticas são adotadas por sua organização para orientar fornecedores com relação à adoção de critérios de sustentabilidade? (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            26. Quais práticas são adotadas por sua organização para orientar fornecedores com relação à adoção de critérios de sustentabilidade? (Assinale todas as opções aplicáveis)
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paOfereceApoio" onChange={event => setPaOfereceApoio(event.target.checked)} checked={ paOfereceApoio ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Oferece apoio técnico (capacitação, orientações sobre produtos e serviços, entre outros)
                            </td>
                            
                        </tr>  

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paDesenvProj" onChange={event => setPaDesenvProj(event.target.checked)} checked={ paDesenvProj ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Desenvolve projetos em parceria com fornecedores

                            </td>
                            
                        </tr>    

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paComPubl" onChange={event => setPaComPubl(event.target.checked)} checked={ paComPubl ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Comunica publicamente seu compromisso e expectativas de compras sustentáveis a todos os fornecedores

                            </td>
                            
                        </tr>   

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paComPrat" onChange={event => setPaComPrat(event.target.checked)} checked={ paComPrat ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Comunica suas práticas e oportunidades aos seus fornecedores

                            </td>
                            
                        </tr>  

                        
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paNaoTem" onChange={event => setPaNaoTem(event.target.checked)} checked={ paNaoTem ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            A organização não tem práticas para orientação de fornecedores com relação à adoção de critérios de sustentabilidade

                            </td>
                            
                        </tr>   

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="paOutra" onChange={event => setPaOutra(event.target.checked)} checked={ paOutra ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outra

                            </td>
                            
                        </tr>  
                        <tr style={{ display: paOutra ? 'table-row' : 'none' }}>
                            <td colspan="2">
                                
                                <input type="text" id="paOutraDescri" maxlength="255" value={paOutraDescri} onChange={event => setPaOutraDescri(event.target.value)} disabled />
                                
                            </td>
                           
                        </tr>  


                    </tbody>
                </Table>

            </div>


            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao27 }} onClick={() => {setEnunciado('27. Quanto ao monitoramento dos resultados e oportunidades de melhorias no processo de compras e contratações incluindo critérios de sustentabilidade, a sua organização:');setSecaoEnunciado('Seção IV');window.$('#modalValidacao').modal('show')}}>
                            27. Quanto ao monitoramento dos resultados e oportunidades de melhorias no processo de compras e contratações incluindo critérios de sustentabilidade, a sua organização:
                            </Link>

                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="oportunidadeMelhorias" onChange={() => setOportunidadeMelhorias('F')} checked={ oportunidadeMelhorias == 'F' ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Monitora os resultados e oportunidades de melhorias contínuas para os processos internamente e com participação de fornecedores
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="oportunidadeMelhorias" onChange={() => setOportunidadeMelhorias('M')} checked={ oportunidadeMelhorias == 'M' ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Monitora os resultados e oportunidades de melhorias contínuas para os processos internamente
                            </td>
                            
                        </tr> 

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="oportunidadeMelhorias"  onChange={() => setOportunidadeMelhorias('P')} checked={ oportunidadeMelhorias == 'P' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            O plano de monitoramento dos resultados e para avaliação de oportunidades de melhorias está em desenvolvimento
                            </td>
                            
                        </tr> 

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="oportunidadeMelhorias" onChange={() => setOportunidadeMelhorias('N')} checked={ oportunidadeMelhorias == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não dispõe ainda de plano de monitoramento dos resultados e para avaliação de oportunidades e melhorias				
                            </td>
                            
                        </tr> 


                        

                    </tbody>
                </Table>

            </div>


            <StatusValidacaoSecao desafio="Compras" totalPendencias={totalPendencias} secaoCampo="secaoIV" nomeDesafio="Desafio Compras" formulario_id={compras_id} secao="Seçao IV - Processo" ano={ano} />

        </div>

    )


}


export default Processo